module.exports = __webpack_public_path__ + "img/email.1df62ac6.svg";